//importing firebase
import {signInWithEmailAndPassword} from "firebase/auth";
import {loginProps} from "./auth_schema";
import {Auth} from "../../firebase/firebase";

export function fbLogin(validatorOutput: loginProps) {
  const email = validatorOutput.username;
  const password = validatorOutput.password;

  return signInWithEmailAndPassword(Auth, email, password)
    .then(() => {
      return true;
    })
    .catch(error => {
      console.error("Failed to sign in. ", error.message);
    });


}
